import tippy from 'tippy.js';

const ANIMATION = 'shift-away';
const DELAY = [300, 0];
const VISIBLE_TIME = 2000;

export default class Tip {
  static flash(element, content) {
    element._tippy?.destroy();

    const tip = tippy(element, { animation: ANIMATION, content, trigger: 'manual' });

    tip.show();

    setTimeout(() => tip.destroy(), VISIBLE_TIME);
  }

  static init(element, { delay = DELAY } = {}) {
    return tippy(element, {
      animation: ANIMATION,
      content: (item) => item.getAttribute('data-tip'),
      delay,
    });
  }

  static update(element, content) {
    element.dataset.tip = content;
    element._tippy?.setContent(content);
  }
}
